import axios from 'axios';
import { configs } from '../app/app-configs';
import { Role, RoleRequest } from './model/role.model';

export const getRoles = async (): Promise<Role[]> => {
    return await axios.get(`${configs.BASE_URL}/role`).then((res) => {
        return res.data as Role[];
    });
};

export const updateRole = async (request: RoleRequest): Promise<Role> => {
    if (!request.id) {
        throw new Error('Role id is required to update a role');
    }

    return await axios
        .put(`${configs.BASE_URL}/role/${request.id}`, request)
        .then((res) => {
            return res.data as Role;
        });
};
